/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReplyPrompt } from "../models/ReplyPrompt";
import type { ReplyPromptUpdate } from "../models/ReplyPromptUpdate";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class SuggestedRepliesService {
  /**
   * Get Reply Prompt
   * What the organization tells Claude to draft suggested replies: its
   * policies, tone and how its program works. Empty means no suggestions.
   * @returns ReplyPrompt Successful Response
   * @throws ApiError
   */
  public static getReplyPrompt({
    orgId,
  }: {
    orgId: number;
  }): CancelablePromise<ReplyPrompt> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/suggested_replies/prompt",
      query: {
        org_id: orgId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }

  /**
   * Set Reply Prompt
   * Store the organization's prompt for suggested replies. Blank turns them
   * off.
   * @returns ReplyPrompt Successful Response
   * @throws ApiError
   */
  public static setReplyPrompt({
    requestBody,
  }: {
    requestBody: ReplyPromptUpdate;
  }): CancelablePromise<ReplyPrompt> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/suggested_replies/prompt",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        422: `Validation Error`,
        500: `Internal Server Error`,
      },
    });
  }
}
